<template>
  <div class="tooltip-wrapper">
    <div
      class="tooltip-wrapper__activator"
      ref="activatorRef"
      @mouseenter="handleVisible(true)"
      @mouseleave="handleVisible(false)"
    >
      <slot name="activator" />
    </div>

    <transition name="fade">
      <div
        v-if="visible"
        class="tooltip-wrapper__body"
        :class="`tooltip-wrapper__body--${position}`"
        :style="{ left: `${tooltipShift}px` }"
      >
        <slot name="body" />

        <svg
          class="tooltip-wrapper__arrow"
          :class="`tooltip-wrapper__arrow--${position}`"
          :style="{ left: `${arrowOffset}px` }"
          :width="ARROW_WIDTH"
          height="12"
          viewBox="0 0 22 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.7295 9.36719C12.313 11.3725 9.27333 11.3341 7.92578 9.22168L1.57813 -0.731447L1.08789 -1.5L20.3926 -1.5L19.9268 -0.739258L13.8613 9.16699L13.7295 9.36719Z"
            fill="#323232"
            stroke="#323232"
          />
        </svg>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
  const props = withDefaults(
    defineProps<{
      position?: 'top' | 'bottom';
      arrowOffset?: number;
    }>(),
    {
      position: 'bottom',
      arrowOffset: 16,
    }
  );

  const ARROW_WIDTH = 20;

  const activatorRef = ref(null);
  const activatorWidth = ref(0);

  const visible = ref(false);

  const position = computed(() => props.position || 'bottom');

  const tooltipShift = computed(() => activatorWidth.value / 2 - props.arrowOffset - ARROW_WIDTH / 2);

  const handleVisible = (value: boolean): void => {
    visible.value = value;
  };

  watch(visible, newVal => {
    if (newVal && activatorRef.value) {
      const { width } = activatorRef.value.getBoundingClientRect();
      activatorWidth.value = width;
    }
  });
</script>
<style src="~/assets/styles/components/tooltip/wrapper.scss" lang="scss" />
